// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, PropTypes } from '@plesk/ui-library';
import Link from './Link';

const Pathbar = ({ items }) => (
    <div className="pathbar clearfix">
        <ul>
            {items.map(({ href, title }) => (
                <li key={href}>
                    <Link to={href}>
                        {title}
                    </Link>
                </li>
            ))}
        </ul>
    </div>
);

Pathbar.propTypes = {
    items: PropTypes.array.isRequired,
};

export default Pathbar;



// WEBPACK FOOTER //
// ./plesk/Pathbar.js